<template>
  <section class="triple-lock">
    <div class="triple-lock__header">
      <div class="triple-lock__header-main">
        <span class="font-semibold text-lg sm:text-[36px] leading-6">What you get with </span>
        <span v-if="affiliateName === 'clear-score'"><img src="@/assets/img/clearscore/triple-lock-clearscore.svg"></span>
        <span
          v-else
          class="font-semibold text-lg sm:text-[36px] leading-6"
        >&nbsp;Borrowell & Spring Financial  </span>
      </div>
      <div class="mb-8">
        Get the peace of mind that what you see is what you get.
      </div>
    </div>
    <div class="triple-lock__features">
      <div
        v-for="feature in featureCardsData"
        :key="feature.title"
        class="triple-lock__feature-card"
      >
        <div class="flex justify-center mb-4">
          <img
            :src="require(`@/assets/img/clearscore/${feature.iconPath}.svg`)"
            alt=""
          >
        </div>
        <div class="text-[18px] font-semibold">
          {{ feature.title }}
        </div>
        <div class="text-md mt-1">
          {{ feature.description }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      affiliateMappings: {
        'springborrowell': 'Borrowell',
        'clear-score': 'ClearScore'
      }
    }
  },
  computed: {
    affiliateName () {
      return this.$store.state.application.affiliateName
    },
    // Update description cards data as per affilate name
    featureCardsData () {
      return [
        {
          iconPath: 'hand-star',
          title: 'Feel confident you’ll be accepted',
          description: `We looked at the information you provided to ${this.affiliateMappings[this.affiliateName]} and have pre-approved you for this offer.`
        },
        {
          iconPath: 'hand-shake',
          title: 'Know you’ll get the money you need',
          description: "You will receive the above loan amount as long as the information you've provided or that is listed on your credit report is up-to-date."
        },
        {
          iconPath: 'person-clock',
          title: 'Know how much it will cost',
          description: "The interest rate of your Spring offer is locked in. So you know exactly how much you'll have to repay at what interest rate before you apply."
        }
      ]
    }
  }
}
</script>

<style lang='scss'>
.triple-lock {
  @screen xxs {
    @apply text-center;
  }

  @screen md {
    @apply text-left;
  }

  &__header {
    &-main {
      @apply flex flex-wrap items-center justify-center;

      @screen xxs {
        @apply mb-3;
      }

      @screen sm {
        @apply mb-2;
      }

      @screen md {
        @apply mb-0 justify-start;
      }
    }

    img {
      @screen xxs {
        @apply w-[273px] h-[45px];
      }

      @screen sm {
        @apply w-[448px] h-[73px];
      }
    }
  }

  &__features {
    @apply flex flex-wrap gap-4;

    @screen xxs {
      @apply gap-4 justify-center;
    }

    @screen md {
      @apply gap-12 justify-start;
    }
  }

  &__feature-card {
    @apply border border-blue-500 rounded-[28px] p-[28px] text-center h-[296px];

    background: #f0fcff;

    @screen xs {
      @apply w-[332px];
    }

    @screen sm {
      @apply w-[472px];
    }

    @screen md {
      @apply w-[352px];
    }
  }
}

</style>
